// Secciones de la app. El menú se arma con ellas y cada rol elige cuáles ve.
// Los id deben coincidir con backend/core/permisos.py (una prueba del backend lo verifica).

// Menú agrupado por lo que se quiere hacer, no por tabla de la base de datos.
export const MENU = [
  {
    grupo: null,
    opciones: [
      { id: "dashboard", label: "Inicio" },
      { id: "mis_turnos", label: "Mis turnos" },
    ],
  },
  {
    grupo: "Reuniones",
    opciones: [
      { id: "reuniones", label: "Calendario" },
      { id: "programacion", label: "Programa" },
      { id: "asistencia", label: "Asistencia" },
    ],
  },
  { grupo: "Servidores", opciones: [{ id: "servidores", label: "Servidores y turnos" }] },
  {
    grupo: "Personas",
    opciones: [
      { id: "miembros", label: "Miembros" },
      { id: "familias", label: "Familias" },
      { id: "visitas_nuevas", label: "Visitas nuevas" },
      { id: "permanencia", label: "Seguimiento" },
      { id: "bajas", label: "Bajas" },
    ],
  },
  {
    grupo: "Mi Casa Kids",
    opciones: [
      { id: "kids_programacion", label: "Programación" },
      { id: "ninos", label: "Niños" },
      { id: "asistencia_ninos", label: "Asistencia de niños" },
      { id: "calificaciones", label: "Calificaciones" },
    ],
  },
  {
    grupo: "Formación y comunicación",
    opciones: [
      { id: "cursos", label: "Cursos" },
      { id: "notificaciones", label: "Mensajes" },
      { id: "encuestas", label: "Encuestas" },
    ],
  },
  { grupo: "Gestión", opciones: [{ id: "proyectos", label: "Proyectos" }] },
  { grupo: null, opciones: [{ id: "configuracion", label: "Configuración" }] },
];

export const MIS_TURNOS = "mis_turnos";
// Configuración (usuarios, roles, tipos de reunión, áreas) es solo de los roles con acceso total.
export const CONFIGURACION = "configuracion";

// Qué permite cada sección, para el editor de roles.
export const AYUDA_SECCION = {
  dashboard: "Resumen y próximas reuniones",
  mis_turnos: "Sus propios turnos, con quién sirve y el programa",
  servidores: "Áreas, turnos y accesos de los servidores",
  kids_programacion: "Rotación y equipo de cada domingo",
  proyectos: "Ver proyectos y comentar; el líder administra su proyecto y el responsable su tarea",
};

// Grupos que se pueden marcar al crear un rol (todo menos Configuración).
export const SECCIONES_ASIGNABLES = MENU.map(({ grupo, opciones }) => ({
  grupo: grupo || "General",
  opciones: opciones.filter((o) => o.id !== CONFIGURACION),
})).filter((g) => g.opciones.length);

// Nombres fuera del menú (p. ej. en la lista de roles), donde el grupo no se ve.
const ETIQUETAS = {
  ...Object.fromEntries(MENU.flatMap((g) => g.opciones).map((o) => [o.id, o.label])),
  kids_programacion: "Programación Kids",
};

export function etiquetaSeccion(id) {
  return ETIQUETAS[id] || id;
}

// Dirección de cada sección: el botón "atrás" del navegador, recargar la página y
// los enlaces guardados abren la misma pantalla. "?reunion=12" abre esa reunión.
export const RUTAS = {
  dashboard: "/inicio",
  mis_turnos: "/mis-turnos",
  reuniones: "/calendario",
  programacion: "/programa",
  asistencia: "/asistencia",
  servidores: "/servidores",
  miembros: "/miembros",
  familias: "/familias",
  visitas_nuevas: "/visitas",
  permanencia: "/seguimiento",
  bajas: "/bajas",
  kids_programacion: "/kids/programacion",
  ninos: "/kids/ninos",
  asistencia_ninos: "/kids/asistencia",
  calificaciones: "/kids/calificaciones",
  cursos: "/cursos",
  notificaciones: "/mensajes",
  encuestas: "/encuestas",
  proyectos: "/proyectos",
  configuracion: "/configuracion",
};

// "?proyecto=4" abre ese proyecto.
export function rutaDe(seccion, datos = {}) {
  const ruta = RUTAS[seccion] || "/";
  if (datos.servicioId) return `${ruta}?reunion=${datos.servicioId}`;
  return datos.proyectoId ? `${ruta}?proyecto=${datos.proyectoId}` : ruta;
}

export function leerRuta(pathname = "/", search = "") {
  const ruta = pathname.replace(/\/+$/, "") || "/";
  const seccion = Object.keys(RUTAS).find((id) => RUTAS[id] === ruta) || null;
  const parametros = new URLSearchParams(search);
  const reunion = Number(parametros.get("reunion"));
  const proyecto = Number(parametros.get("proyecto"));
  if (reunion > 0) return { seccion, contexto: { servicioId: reunion } };
  return { seccion, contexto: proyecto > 0 ? { proyectoId: proyecto } : {} };
}

export function puedeVer(usuario, seccion) {
  const acceso = usuario?.acceso;
  if (!acceso || !ETIQUETAS[seccion]) return false; // Sección inexistente (p. ej. una dirección mal escrita).
  if (acceso.total) return seccion !== MIS_TURNOS || Boolean(usuario.miembro_id);
  if (seccion === CONFIGURACION) return false;
  return (acceso.secciones || []).includes(seccion);
}

// Menú con solo lo que el usuario puede ver.
export function menuDe(usuario) {
  return MENU.map(({ grupo, opciones }) => ({ grupo, opciones: opciones.filter((o) => puedeVer(usuario, o.id)) }))
    .filter((g) => g.opciones.length);
}

export function primeraSeccion(usuario) {
  return menuDe(usuario)[0]?.opciones[0]?.id || null;
}

// Solo los administradores crean y editan usuarios y roles.
export function administraUsuarios(usuario) {
  return Boolean(usuario?.acceso?.admin);
}

// Quien solo ve sus turnos usa la vista sencilla de servidor (pensada para el celular).
export function soloVeSusTurnos(usuario) {
  const acceso = usuario?.acceso;
  return Boolean(acceso && !acceso.total && (acceso.secciones || []).every((s) => s === MIS_TURNOS));
}
